export const BASE_URL_API = import.meta.env.VITE_BASE_URL_API;

export const ELASTIC_URL = import.meta.env.VITE_ELASTIC_URL;

export const BASE_WS_URL = import.meta.env.VITE_BASE_URL_WS;

export const USER_ROLES = {
  ADMIN: {
    title: 'Адміністратор',
    value: 'Admin',
  },
  EXECUTOR: {
    title: 'Виконавець процесу',
    value: 'Executor',
  },
  CONTROLLER: {
    title: 'Контролер процесу',
    value: 'Supervisor',
  },
  EXTERNAL_SYSTEM: {
    title: 'Зовнішня система',
    value: 'External',
  },
} as const;

export type UserRoleType =
  (typeof USER_ROLES)[keyof typeof USER_ROLES]['value'];

export const RESOLUTION_OPTIONS = [
  { value: '500x500', label: '500 x 500 (px)' },
  { value: '1000x1000', label: '1000 x 1000 (px)' },
  { value: '2000x2000', label: '2000 x 2000 (px)' },
  { value: '4000x4000', label: '4000 x 4000 (px)' },
  { value: '5000x5000', label: '5000 x 5000 (px)' },
] as const;

export const INSURANCE_AREA = {
  INSURANCE: 'Страхування',
  SETTLEMENT: 'Врегулювання',
} as const;

export const INDEX_OBJECT_TYPES = {
  VEHICLE: 'Транспортний засіб',
  PROPERTY: 'Майно',
} as const;

export const USER_STATUS = {
  ACTIVE: 'Активний',
  INACTIVE: 'Неактивний',
} as const;

export const PROCESS_TYPES = {
  BASIC: 'Базовий процес',
  ADDITIONAL: 'Додатковий процес',
} as const;

export const FILE_TYPES = {
  IMAGE: {
    mime: 'image/*',
    extensions: ['.jpg', '.jpeg', '.png', '.gif'] as const,
    label: 'Зображення',
    test: /\.(jpe?g|png|gif|bmp|webp)$/i,
    icon: {
      type: 'img',
      color: 'dark-red',
    },
  },
  VIDEO: {
    mime: 'video/*',
    extensions: ['.mp4', '.mov', '.avi'] as const,
    label: 'Відео',
    test: /\.(mp4|webm|mov|avi)$/i,
    icon: {
      type: 'video',
      color: 'dark-red',
    },
  },
  PDF: {
    mime: 'application/pdf',
    extensions: ['.pdf'] as const,
    label: 'Документ',
    test: /\.pdf$/i,
    icon: {
      type: 'pdf',
      color: 'dark-red',
    },
  },
  DOCUMENT: {
    mime: 'application/msword',
    extensions: ['.doc', '.docx'] as const,
    label: 'Документ',
    test: /\.(doc|docx)$/i,
    icon: {
      type: 'docx',
      color: 'dark-red',
    },
  },
  IMAGE_HEIC: {
    mime: 'image/heic',
    extensions: ['.heic', '.heif'] as const,
    label: 'Зображення',
    test: /\.(heic|heif)$/i,
    icon: {
      type: 'heic',
      color: 'dark-red',
    },
  },
} as const;

// Helper functions for file type checking
export const isFileType = (fileName: string, type: keyof typeof FILE_TYPES) =>
  FILE_TYPES[type].test.test(fileName.toLowerCase());

export const getFileType = (
  fileName: string,
): keyof typeof FILE_TYPES | null => {
  const name = fileName.toLowerCase();
  return (
    (Object.keys(FILE_TYPES) as Array<keyof typeof FILE_TYPES>).find((type) =>
      FILE_TYPES[type].test.test(name),
    ) || null
  );
};

// For backward compatibility (can be removed later)
export const ACCEPTED_FILE_TYPES = Object.entries(FILE_TYPES).reduce(
  (acc, [_, value]) => ({
    ...acc,
    [value.mime]: [...value.extensions],
  }),
  {} as Record<string, string[]>,
);

export const FILE_TYPE_NAMES = Object.entries(FILE_TYPES).reduce(
  (acc, [_, value]) => ({
    ...acc,
    [value.mime]: value.label,
  }),
  {} as Record<string, string>,
);

export const FILE_UPLOAD_STATUS = {
  PENDING: 'Очікує Завант.',
  UPLOADING: 'Завантаження',
  VALIDATED: 'Опрацьовано',
  UPLOAD_FAILED: 'Помилка завантаження',
  VALIDATION_FAILED: 'Помилка валідації',
} as const;

export type FileUploadStatusType =
  (typeof FILE_UPLOAD_STATUS)[keyof typeof FILE_UPLOAD_STATUS];

export const ROOT_UUID = 'root';

export const AGREEMENT_ROOT_NAME = 'Список документів';

export const START_STEP_NAME = 'Новий';
export const END_STEP_NAME = 'В Архів';
export const ROW_HEIGHT = 70;
export const ROW_HEIGHT_SMALL = 60;
